<template>
  <div>
    <div class="row menubar">
      <div class="title">U-Rend.</div>
      <input
        disabled type=text
        v-model="urendement" placeholder="U-Rendement"
        style="width:60px;border-right:none;border-radius:0;"
      >
      <div class="title">Rekenrend.</div>
      <input
        type=text
        v-model="rekenRendement" placeholder="Rekenrendement"
        style="width:60px;border-right:none;border-radius:0;"
      >
      <div class="title">Max jaar</div>
      <input
        disabled type=text v-model="maxjaar" placeholder="Max jaar"
        style="width:60px;border-right:none;border-radius:0;"
      >
      <div class="title">Portefeuille</div>
      <input
        type=text v-model="port" placeholder="Portefeuille"
        style="width:120px;border-right:none;border-radius:0;"
      >
      <button @click="lookupPort=!lookupPort">
        <awesomeIcon icon="bars"/>
      </button>
      <button
        v-if="revisions.length > 1"
        @click="newRevision = revision; revisionModal = true"
        style="float: right"
      >
        <awesomeIcon icon="sync"/> Laad revisie ({{ revision }})
      </button>
      <button @click="save" style="float: right;">
        <awesomeIcon icon="upload"/> Opslaan
      </button>
      <button @click="load" style="float: right;">
        <awesomeIcon icon="download"/> Laden
      </button>
    </div>

    <modalWindow v-show="lookupYear" @close="lookup(null, null)" width="800">
      <div class="titlebar">
        Lookup stand voor jaar {{lookupYear}} maand {{lookupMonth}} voor {{port}}
      </div>
      <div class="viewport">
        <span
          v-for="d, index in dates" :key="d"
          style="display: block;width: 145px;float: left;"
        >
          {{d}} <button @click="dates.splice(index, 1);storeDates()">
            x
          </button>
        </span>
        <div class="sm-col-12 lg-colnm-12">
          <customInput
            v-model="portDate" type="date" label="Waardedatum"
            class="sm-col-12 lg-colnm-6"
          />
          <button @click="addDate">Toevoegen</button>
        </div>
        <table>
          <tr>
            <th>Datum</th><th>Waarde</th><th>Actie</th><th>Automatisch</th>
          </tr>
          <tr v-for="(portValue, index) in portValues" :key="portValue.date">
            <td>{{portValue.date}}</td>
            <td>{{formatPrice(Number(portValue.worth))}}</td>
            <td>
              <button @click="stand[lookupYear][lookupMonth]=portValue.worth;lookup(null,null)">
                Kies
              </button>
            </td>
            <td>{{
              portValues.length === 13 || Number(lookupMonth) !== 0
                ? calcOffset(index, lookupYear, lookupMonth)
                : 'select 13 dates'
            }}</td>
          </tr>
        </table>
        <button
          v-if="
            portValues.length === 13 && Number(lookupMonth) === 0
            && !(
              this.uitbetalingen[Number(lookupYear) - 1]
              && Number(this.uitbetalingen[Number(lookupYear) - 1]) !== 12
              && Number(this.uitbetalingen[Number(lookupYear) - 1]) !== 4
              && Number(this.uitbetalingen[Number(lookupYear) - 1]) !== 2
              && Number(this.uitbetalingen[Number(lookupYear) - 1]) !== 1
            )
          "
          @click="fillOffsets(lookupYear, lookupMonth)"
        >
          Vul in zoals boven beschreven
        </button>
      </div>
    </modalWindow>

    <modalWindow v-show="revisionModal" @close="revisionModal=!revisionModal" width="400">
      <div class="titlebar">
        Wijzigen revisie
      </div>
      <div class="viewport" style="min-height: 400px; height: auto;">
        <p>
          <b>
            De huidige revisie voor port. {{ revisionPort }} is {{ revision }}. <br /><br />
            Hier kunt u de gewenste revisie van de porteuille laden.
          </b>
        </p>
        <div class="flex-container flex-grow">
          <customInput
            v-model="newRevision"
            type="dropdown"
            label="Revisie"
            :validation="['notrequired']"
            :options="revisions"
          />
        </div>
        <button
          :class="[newRevision && newRevision !== revision ? '' : 'disabled']"
          @click="changeRevision()"
          style="display: block; width: 100%; margin-top: 20px;"
        >
          Wijzig revisie naar {{ newRevision || '-' }}
        </button>
      </div>
    </modalWindow>

    <modalWindow v-show="lookupPort" @close="lookupPort=!lookupPort" width="800">
      <div class="titlebar">Lookup portefeuilles</div>
      <div class="viewport">
        <table>
          <tr>
            <th>Port</th>
            <th>Interval</th>
            <th>Volgende uitbetaling</th>
            <th>Volgende verjaardag</th>
            <th>Revisie</th>
            <th>Actie</th>
          </tr>
          <tr v-for="payout in sortBy(payouts, [
            'nextPayout',
            'nextBirthday',
          ])" :key="payout.port" :class="{
            red : payout.nextPayout <= `${new Date().getFullYear()}-${
              new Date().getMonth() > 8
              ? new Date().getMonth() + 1
              : `0${new Date().getMonth() + 1}`
            }`
          }">
            <td>{{payout.port}}</td>
            <td>{{payout.frequency}}</td>
            <td>{{payout.nextPayout}}</td>
            <td>{{payout.nextBirthday}}</td>
            <td>{{formatPrice(Number(payout.revision), true)}}</td>
            <td>
              <button @click="port=payout.port;lookupPort=!lookupPort;load()">
                Vul in en laad
              </button>
            </td>
          </tr>
        </table>
      </div>
    </modalWindow>

    <div class="scroll-container" v-if="maxjaar">
      <table>
        <tr>
          <th>
            Maanden interval<br>
            <select v-model="frequency">
              <option v-for="freq in frequencies" :key="freq.value" :value="freq.value">
                {{freq.label}}
              </option>
            </select>
          </th>
          <th>
            Startdatum<br>
            <input v-model="startDate" type="date">
          </th>
          <th>
            Laaste actie<br>
            <input v-model="lastPayout" type="date">
          </th>
          <th>
            <button @click="lastPayout=`${
              (new Date()).getFullYear()
            }-${
              (new Date()).getMonth() > 8
              ? (new Date()).getMonth() + 1
              : `0${(new Date()).getMonth() + 1}`
            }-${
              (new Date()).getDate() > 9
              ? (new Date()).getDate()
              : `0${(new Date()).getDate()}`
            }`">Vandaag</button>
          </th>
        </tr>
      </table>
      <table>
        <tr>
          <!-- <th>Datum</th> -->
          <th>Type</th>
          <th style="border-right: 2px solid black">Totaal</th>
          <th v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
            {{51 - index}}
          </th>
        </tr>
        <template v-for="year in Number(maxjaar)">
          <!-- start -->
          <tr
            :key="`head-${year}`"
            style="background-color: lightgray;border-top: 4px solid black"
            v-if="!stand[year - 1] || stand[year - 1][0] > 0"
          >
            <th>
              {{year}}e jaar beginstand
            </th>
            <th v-if="year == 1" style="border-right: 2px solid black">
              {{stand[year][0] ? formatPrice(stand[year][0], true) : 0}}
            </th>
            <th v-else style="border-right: 2px solid black">
              <span v-if="standOriginals[year + 1][0]">
                {{formatPrice(Number(standOriginals[year][0]))}}
              </span>
              <input
                v-show="!standOriginals[year + 1][0]"
                v-model="standOriginals[year][0]" @keyup="calc"
                :placeholder="formatPrice(stand[year][0], true)"
              >
              <button v-show="!standOriginals[year + 1][0]" @click="lookup(year,0)">
                <awesomeIcon icon="search" />
              </button>
            </th>
            <template v-if="year == 1">
              <td v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
                <input v-show="false" disabled v-model="initieel[index]">
                {{initieel[index] ? formatPrice(initieel[index], true) : '..'}}
              </td>
            </template>
            <template v-else>
              <td v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
                {{result[year] ? formatPrice(result[year].waardes[0][index], true) : '..'}}
              </td>
            </template>
          </tr>
          <tr
            :key="`calc-${year}`"
            style="background-color: lightgray;border-bottom: 4px solid black"
            v-if="!stand[year - 1] || stand[year - 1][0] > 0"
          >
            <td>
              uitbetaling berekening in<br>
              <span v-if="standOriginals[year + 1][0]">
                {{uitbetalingen[year] ? uitbetalingen[year] : freqToInterval(frequency)}}
              </span>
              <input
                v-show="!standOriginals[year + 1][0]"
                v-model="uitbetalingen[year]" :placeholder="freqToInterval(frequency)"
              > gelijke delen
            </td>
            <td style="border-right: 2px solid black">
              {{result[year] ? formatPrice(sum(result[year].uitbetaling[0])) : '..'}}
            </td>
            <td v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
              {{result[year] ? formatPrice(result[year].uitbetaling[0][index]) : '..'}}
            </td>
          </tr>
          <!-- uitbetalingen -->
          <template v-for="payout in Number(
            uitbetalingen[year]
              ? uitbetalingen[year]
              : freqToInterval(frequency)
          )">
            <tr
              :key="`payout-value-${year}-${payout}`"
              v-if="!stand[year - 1] || stand[year - 1][0] > 0"
            >
              <td>
                Portefeuille waarde
              </td>
              <td style="border-right: 2px solid black">
                <span v-if="standOriginals[year + 1][0]">
                  {{stand[year][payout] ? formatPrice(Number(stand[year][payout]), true) : 0}}
                </span>
                <input
                  v-show="!standOriginals[year + 1][0]"
                  v-model="standOriginals[year][payout]" @keyup="calc"
                  :placeholder="stand[year][payout] ? formatPrice(stand[year][payout], true) : 0"
                >
                <button v-show="!standOriginals[year + 1][0]" @click="lookup(year,payout)">
                  <awesomeIcon icon="search" />
                </button>
              </td>
              <td v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
                {{
                  result[year] && result[year].waardes && result[year].waardes[payout]
                  ? formatPrice(result[year].waardes[payout][index]) : '..'
                }}
              </td>
            </tr>
            <tr
              :key="`payout-${year}-${payout}`"
              v-if="!stand[year - 1] || stand[year - 1][0] > 0"
              style="border-bottom: 2px solid gray"
            >
              <td>
                {{payout}}e uitbetaling
              </td>
              <td style="border-right: 2px solid black">
                {{
                  result[year] && result[year].uitbetaling && result[year].uitbetaling[payout]
                  ? formatPrice(sum(result[year].uitbetaling[payout])) : '..'
                }}
              </td>
              <td v-for="index in 46" :key="index" v-show="Number(maxjaar) >= 51 - index">
                {{
                  result[year] && result[year].uitbetaling && result[year].uitbetaling[payout]
                  ? formatPrice(result[year].uitbetaling[payout][index]) : '..'
                }}
              </td>
            </tr>
          </template>
          <!-- einde -->
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import {
  sortBy, sum, includes, cloneDeep,
} from 'lodash-es';

/* eslint-disable */
export default {
  name: 'AdminPayouts',
  data() {
    return {
      stand: {
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        12: {},
        13: {},
        14: {},
        15: {},
        16: {},
        17: {},
        18: {},
        19: {},
        20: {},
        21: {},
        22: {},
        23: {},
        24: {},
        25: {},
        26: {},
        27: {},
        28: {},
        29: {},
        30: {},
        31: {},
        32: {},
        33: {},
        34: {},
        35: {},
        36: {},
        37: {},
        38: {},
        39: {},
        40: {},
        41: {},
        42: {},
        43: {},
        44: {},
        45: {},
        46: {},
        47: {},
        48: {},
        49: {},
        50: {},
      },
      standOriginals: {
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        12: {},
        13: {},
        14: {},
        15: {},
        16: {},
        17: {},
        18: {},
        19: {},
        20: {},
        21: {},
        22: {},
        23: {},
        24: {},
        25: {},
        26: {},
        27: {},
        28: {},
        29: {},
        30: {},
        31: {},
        32: {},
        33: {},
        34: {},
        35: {},
        36: {},
        37: {},
        38: {},
        39: {},
        40: {},
        41: {},
        42: {},
        43: {},
        44: {},
        45: {},
        46: {},
        47: {},
        48: {},
        49: {},
        50: {},
      },
      resetStand: {
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        12: {},
        13: {},
        14: {},
        15: {},
        16: {},
        17: {},
        18: {},
        19: {},
        20: {},
        21: {},
        22: {},
        23: {},
        24: {},
        25: {},
        26: {},
        27: {},
        28: {},
        29: {},
        30: {},
        31: {},
        32: {},
        33: {},
        34: {},
        35: {},
        36: {},
        37: {},
        38: {},
        39: {},
        40: {},
        41: {},
        42: {},
        43: {},
        44: {},
        45: {},
        46: {},
        47: {},
        48: {},
        49: {},
        50: {},
      },
      dates: [],
      uitbetalingen: [0],
      initieel: [],
      result: {},
      urendement: '0',
      rekenRendement: '1.04',
      forehand: '0',
      maxjaar: '',
      port: '',
      frequency: null,
      frequencies: [
        { label: 'Per maand', value: '1' },
        { label: 'Per kwartaal', value: '3' },
        { label: 'Per halfjaar', value: '6' },
        { label: 'Per jaar', value: '12' },
      ],
      startDate: null,
      lastPayout: null,
      lookupYear: null,
      lookupMonth: null,
      portDate: (new Date()).toISOString(),
      portValues: [],
      lookupPort: false,
      revisionModal: false,
      payouts: [],
      cashflow: [],
      newRevision: '',
      revision: '',
      revisions: [],
      revisionPort: '',
    };
  },
  created() {
    if (this.readCookie('payout_dates')) {
      this.dates = JSON.parse(this.readCookie('payout_dates'));
    } else {
      const date = new Date(this.portDate);
      date.setDate(date.getDate() - 1);
      this.dates.push(
        `${date.getFullYear()}-${
          date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
        }-${
          date.getDate() < 10 ? '0' : ''}${date.getDate()
        }`
      );
    }
    if (this.$parent.other) {
      this.port = this.$parent.other;
      this.$parent.other = '';
      this.load();
    }
  },
  watch: {
    frequency() {
      this.calc();
    },
    stand() {
      this.calc();
    },
    uitbetalingen() {
      this.calc();
    },
    initieel() {
      this.calc();
    },
    rekenRendement() {
      this.calc();
    },
    urendement() {
      this.calc();
    },
    forehand() {
      this.calc();
    },
    lookupPort() {
      if (this.lookupPort) {
        this.sdk.getAdminPayouts((response) => {
          if (response.status === 200) {
            for (let i = 0; i < response.data.length; i += 1) {
              if (response.data[i].start_date == '0000-00-00') {
                response.data[i].start_date = null;
              }
              if (response.data[i].lastpayout_date == '0000-00-00') {
                response.data[i].lastpayout_date = null;
              }
              response.data[i].lastPayoutDate = response.data[i].lastpayout_date
                ? new Date(response.data[i].lastpayout_date)
                : '?'
              ;
              response.data[i].nextBirthdayDate = '?';
              if (response.data[i].start_date) {
                const calcBirthDay = new Date(response.data[i].start_date)
                while (response.data[i].lastPayoutDate >= calcBirthDay) {
                  calcBirthDay.setFullYear(calcBirthDay.getFullYear() + 1);
                }
                response.data[i].nextBirthdayDate = calcBirthDay;
              }
              response.data[i].nextBirthday = response.data[i].nextBirthdayDate == '?'
                ? response.data[i].nextBirthdayDate
                : this.formatDate(response.data[i].nextBirthdayDate, false)
              ;

              response.data[i].nextPayoutDate = '?';
              if (response.data[i].lastpayout_date) {
                const calcNextPayout = new Date(response.data[i].lastpayout_date)
                calcNextPayout.setMonth(calcNextPayout.getMonth() + response.data[i].frequency);
                response.data[i].nextPayoutDate = calcNextPayout;
              } else if (response.data[i].start_date) {
                response.data[i].nextPayoutDate = new Date(response.data[i].start_date);
              }
              response.data[i].nextPayout = response.data[i].nextPayoutDate == '?'
                ? response.data[i].nextPayoutDate
                : this.formatDate(response.data[i].nextPayoutDate, false)
              ;
            }
            this.payouts = response.data;
          }
        });
      } else {
        this.payouts = [];
      }
    },
    startDate() {
      this.calc();
    },
  },
  methods: {
    sum,
    sortBy,
    changeRevision() {
      this.sdk.getPayoutRevision(this.revisionPort, Number(this.newRevision), (response) => {
        if (response.status === 200) {
          this.newRevision = '';
          this.revisionModal = false;
          if (response.status === 200 && response.data[0]) {
            this.result = {};
            this.revisionPort = response.data[0].port;
            this.revision = `${response.data[0].revision}`;
            this.maxjaar = response.data[0].years;
            this.urendement = response.data[0].interest;
            this.rekenRendement = response.data[0].calc_interest || '1.04';
            this.forehand = response.data[0].forehand;
            let tempInitials = JSON.parse(response.data[0].initials);
            if (tempInitials.length === 31) {
              tempInitials.unshift(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
            this.initieel = tempInitials;
            this.uitbetalingen = JSON.parse(response.data[0].payouts);
            this.standOriginals = cloneDeep(this.resetStand);
            this.stand = cloneDeep(this.resetStand);
            this.frequency = response.data[0].frequency;
            this.startDate = this.formatDate(new Date(response.data[0].start_date));
            this.lastPayout = this.formatDate(new Date(response.data[0].lastpayout_date));
            Object.assign(this.standOriginals, JSON.parse(response.data[0].overtimes));
            Object.assign(this.stand, JSON.parse(response.data[0].overtimes));
          }
        } else {
          this.$store.state.confirm.toggle({
            text: response.data.message,
            title: 'Er is iets misgegaan',
            alert: true,
            confirmText: 'Terug',
            cb: () => {},
          });
        };
      });
    },
    calcOffset(index, year, month) {
      if (Number(month) === 0) {
        if (
          this.uitbetalingen[Number(year) - 1]
          && Number(this.uitbetalingen[Number(year) - 1]) !== 12
          && Number(this.uitbetalingen[Number(year) - 1]) !== 4
          && Number(this.uitbetalingen[Number(year) - 1]) !== 2
          && Number(this.uitbetalingen[Number(year) - 1]) !== 1) {
          return `${this.uitbetalingen[Number(year) - 1]} parts not supported`
        }
        if (index === 12) {
          return `jaar ${year} verjaardag`;
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 1)
          || Number(this.uitbetalingen[Number(year) - 1]) === 12
        ) {
          return `jaar ${Number(year) - 1} month ${index + 1}`
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 3)
          || (Number(this.uitbetalingen[Number(year) - 1]) === 4 && index % 3 === 0)
        ) {
          return `${Number(year) - 1} kwartaal ${Math.ceil((index + 1) / 3)}`;
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 6)
          || (Number(this.uitbetalingen[Number(year) - 1]) === 2 && index % 6 === 0)
        ) {
          return `jaar ${Number(year) - 1} halfjaar ${Math.ceil((index + 1) / 6)}`;
        }
        if (index === 0) {
          return `jaar ${Number(year) - 1} uitbetaling 1`;
        }
        return '-';
      }
      return 'go to year value';
    },
    fillOffsets(year) {
      for (let index = 0;index < this.portValues.length;index += 1) {
        if (index === 12) {
          this.stand[Number(year)][0]=this.portValues[index].worth;
          this.standOriginals[Number(year)][0]=this.portValues[index].worth;
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 1)
          || Number(this.uitbetalingen[Number(year) - 1]) === 12
        ) {
          this.stand[Number(year) - 1][index + 1]=this.portValues[index].worth;
          this.standOriginals[Number(year) - 1][index + 1]=this.portValues[index].worth;
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 3)
          || (Number(this.uitbetalingen[Number(year) - 1]) === 4 && index % 3 === 0)
        ) {
          this.stand[Number(year) - 1][Math.ceil((index + 1) / 3)]=this.portValues[index].worth;
          this.standOriginals[Number(year) - 1][Math.ceil((index + 1) / 3)]=this.portValues[index].worth;
        }
        if (
          (!this.uitbetalingen[Number(year) - 1] && Number(this.frequency) === 6)
          || (Number(this.uitbetalingen[Number(year) - 1]) === 2 && index % 6 === 0)
        ) {
          this.stand[Number(year) - 1][Math.ceil((index + 1) / 6)]=this.portValues[index].worth;
          this.standOriginals[Number(year) - 1][Math.ceil((index + 1) / 6)]=this.portValues[index].worth;
        }
        if (index === 0) {
          this.stand[Number(year) - 1][1]=this.portValues[index].worth;
          this.standOriginals[Number(year) - 1][1]=this.portValues[index].worth;
        }
      }
      this.calc();
      this.lookup(null,null);
    },
    formatDate(date, showDate = true) {
      if (!showDate) {
        return `${date.getFullYear()}-${
          date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
        }`;
      }
      return `${date.getFullYear()}-${
        date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
      }-${
        date.getDate() < 10 ? '0' : ''}${date.getDate()
      }`;
    },
    addDate() {
      const date = new Date(this.portDate);
      let dateString = this.formatDate(date);
      if (!includes(this.dates, dateString)) {
        this.dates.push(dateString);
        this.createCookie('payout_dates', JSON.stringify(this.dates));
        this.lookup(this.lookupYear, this.lookupMonth);
      }
    },
    storeDates() {
      this.createCookie('payout_dates', JSON.stringify(this.dates));
      this.lookup(this.lookupYear, this.lookupMonth);
    },
    lookup(year, month) {
      this.lookupYear = year;
      this.lookupMonth = month;
      this.sdk.getPerformanceOn(
        this.port,
        { dates: JSON.stringify(this.dates) },
        (response) => {
          this.portValues = response.data;
        },
      );
    },
    load() {
      this.sdk.getPayouts(this.port, (response) => {
        if (response.status === 200 && response.data[0]) {
          this.result = {};
          this.revisions = [];
          this.revisionPort = response.data[0].port;
          this.revision = `${response.data[0].revision}`;
          for (let i = 0; i <= response.data[0].revision; i += 1) {
            this.revisions.push(
              {
                label: `${i}`,
                value: `${i}`,
              }
            );
          }
          this.maxjaar = response.data[0].years;
          this.urendement = response.data[0].interest;
          this.rekenRendement = response.data[0].calc_interest || '1.04';
          this.forehand = response.data[0].forehand;
          let tempInitials = JSON.parse(response.data[0].initials);
          if (tempInitials.length === 31) {
            tempInitials.unshift(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          }
          this.initieel = tempInitials;
          this.uitbetalingen = JSON.parse(response.data[0].payouts);
          this.standOriginals = cloneDeep(this.resetStand);
          this.stand = cloneDeep(this.resetStand);
          this.frequency = response.data[0].frequency;
          this.startDate = this.formatDate(new Date(response.data[0].start_date));
          this.lastPayout = this.formatDate(new Date(response.data[0].lastpayout_date));
          Object.assign(this.standOriginals, JSON.parse(response.data[0].overtimes));
          Object.assign(this.stand, JSON.parse(response.data[0].overtimes));
          this.calc();
        }
      });
    },
    save() {
      this.sdk.modifyPayouts(
        this.port,
        this.maxjaar,
        this.urendement,
        JSON.stringify(this.initieel),
        JSON.stringify(this.standOriginals),
        JSON.stringify(this.uitbetalingen),
        this.forehand,
        this.startDate,
        this.lastPayout,
        this.frequency,
        this.cashflow,
        this.rekenRendement,
        (response) => {
          if (response.status === 200) {
            this.load();
            alert('De uitbetalingen zijn opgeslagen.');
          }
        },
      );
    },
    freqToInterval(freq) {
      if (Number(freq) === 1) {
        return 12;
      }
      if (Number(freq) === 3) {
        return 4;
      }
      if (Number(freq) === 6) {
        return 2;
      }
      return 1;
    },
    calc() {
      this.result = {};
      this.cashflow = [];
      this.standOriginals[1][0] = sum(this.initieel.map(o => Number(o)));
      Object.assign(this.stand, cloneDeep(this.standOriginals));
      const cashflowDate = new Date(this.startDate);
      cashflowDate.setHours(12);
      for (let i = 1; i <= 50; i += 1) {
        const result = {
          stand: [],
          uitbetaling: [],
          waardes: [],
        };
        const aantalUitbetaling = Number(this.uitbetalingen[i] ? this.uitbetalingen[i] : this.freqToInterval(this.frequency));
        const vorigeAantalUitbetaling = Number(this.uitbetalingen[i - 1]
          ? this.uitbetalingen[i - 1]
          : this.freqToInterval(this.frequency)
        );
        for (let p = 0; p <= aantalUitbetaling; p += 1) {
          result.stand[p] = Number(this.stand[i] && this.stand[i][p] ? this.stand[i][p] : 0);
          let newVal = false;
          if (result.stand[p] === 0) {
            newVal = true;
            if (p === 0 && i === 1) {
              result.stand[p] = this.stand[1][0];
            } else if (p === 0 && i <= this.maxjaar) {
              result.stand[p] = this.result[i - 1].stand[vorigeAantalUitbetaling] - this.cashflow[this.cashflow.length - 1].payout;
            } else if (p > 0) {
              const rendement = this.rekenRendement ** (1 / aantalUitbetaling);
              result.stand[p] = result.stand[p - 1] * rendement;
            }
          }
          if (result.stand[p] > 0) {
            this.stand[i][p] = result.stand[p];
          }
          if (p > 0) {
            this.cashflow.push({ date: cashflowDate.toLocaleDateString(), payout: sum(result.uitbetaling[0]) / aantalUitbetaling });
            if (aantalUitbetaling === 12) {
              cashflowDate.setMonth(cashflowDate.getMonth() + 1);
            } else if (aantalUitbetaling === 4) {
              cashflowDate.setMonth(cashflowDate.getMonth() + 3);
            } else if (aantalUitbetaling === 2) {
              cashflowDate.setMonth(cashflowDate.getMonth() + 6);
            } else {
              cashflowDate.setFullYear(cashflowDate.getFullYear() + 1);
            }
          }
          if (p > 0 && p < aantalUitbetaling && newVal) {
            result.stand[p] -= this.cashflow[this.cashflow.length - 1].payout;
          }
          result.waardes[p] = [];
          result.uitbetaling[p] = [];
          for (let j = 1; j <= 46; j += 1) {
            let verdeling = 0;
            if (p === 0 && i === 1) {
              // initiele verdeling
              verdeling = Number(this.initieel[j] ? this.initieel[j] : 0) / result.stand[p];
            } else if (p === 0) {
              // overige calculatie verdeling
              verdeling = (
                this.result[i - 1].waardes[vorigeAantalUitbetaling][j] - this.result[i - 1].uitbetaling[vorigeAantalUitbetaling][j]
              ) / (
                this.result[i - 1].stand[vorigeAantalUitbetaling] - sum(this.result[i - 1].uitbetaling[vorigeAantalUitbetaling])
              );
            } else if (p === 1) {
              // eerste uitbetaling na calculatie
              verdeling = result.waardes[p - 1][j] / result.stand[p - 1];
            } else {
              // overige uitbetalingen
              verdeling = (
                result.waardes[p - 1][j] - result.uitbetaling[p - 1][j]
              ) / (
                result.stand[p - 1] - sum(result.uitbetaling[p - 1])
              );
            }
            if (isNaN(verdeling)) {
              verdeling = 0;
            }
            result.waardes[p][j] = (result.stand[p] * verdeling);
            if (52 - i - j < 1) {
              result.uitbetaling[p][j] = 0;
            } else if (p === 0) {
              result.uitbetaling[p][j] = this.PMT(Number(this.urendement) / 100, 52 - i - j, -result.stand[p] * verdeling, 0, this.forehand);
            } else if (p === aantalUitbetaling && 52 - i - j === 1) {
              result.uitbetaling[p][j] = result.stand[p] * verdeling;
            } else {
              result.uitbetaling[p][j] = Math.min(
                result.stand[p] * verdeling,
                result.uitbetaling[0][j] / aantalUitbetaling,
              );
            }
          }
        }
        this.result[i] = result;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .scroll-container {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
  }
</style>
